import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import About from './Componenets/About';
import Resume from './Componenets/Resume';
import Projects from './Componenets/Projects';
import Header from './Componenets/Common/Header';
import {Container} from "react-bootstrap";
import './App.css';

class App extends React.Component {
  constructor(props) {
    super(props);
    const Config = require('./config.json');

    this.state = {
      config: Config,
    };
  }


  render() {
    let hideHeader = '';
    const params = new URLSearchParams(window.location.search);

    if (params.has('print') || params.has('nohead')){
      if (params.has('print')) {
        hideHeader = <>{window.print()} {window.close()}</>;
      } else {
        hideHeader = <></>;
      }
    }

    return (

      <Router>
        {hideHeader ? (hideHeader) : (<><Header /></>)}
        <Container fluid style={{ paddingTop: '2em', paddingLeft: '2em'}}>
        <Switch>
          <Route
            exact strict path={'/'} render={({ match }) => (
            <About match={match} />
            )} />
          <Route
            exact strict path={'/work'} render={({ match }) => (
            <Resume match={match} />
            )} />
          <Route
            exact strict path={'/projects'} render={({ match }) => (
            <Projects match={match} />
            )} />
        </Switch>
        </Container>
      </Router>
    );
  }
}

export default App;
